export const availableLanguages = [
  { code: "en", label: "English", required: true },
  { code: "fr", label: "French" },
  // To add Spanish later: { code: "es", label: "Spanish" }
];

export const defaultSupportedLanguagesForNewCampaign = ["en"];
export const legacyFallbackSupportedLanguages = ["en", "fr"];
